import React from 'react'
import { Box, Container, Flex, Heading, Highlight, Icon, IconButton, Image, SimpleGrid, Stack, Text } from '@chakra-ui/react'
import { useEffect } from 'react';
import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import AOS from 'aos'
import VanillaTilt from 'vanilla-tilt';
import 'aos/dist/aos.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { certificate } from "../data"
const settings = {
    className: "center",
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 10000,
    autoplaySpeed: 4000,
    cssEase: "linear",
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            }
        }
    ],
};

const Certificates = () => {
    const { Theme } = useContext(ThemeContext)
    useEffect(() => {
        AOS.init();
    }, [])

    const options = {
        scale: 1.1,
        speed: 1000,
        max: 30
    };
    return (
        <section className={`${Theme === 'dark' ? "newBackground" : "bg-white"} bg-transition `} >
            <div className={`sm:pb-20 `} >
                <Tilt1 options={options} Theme={Theme} />
                <Flex mt="50px" >
                    <Slider {...settings}>
                        {
                            certificate.map((el) => {
                                return (
                                    <Flex className="lisa" data-aos="zoom-in-left"  data-aos-duration="3000" backgroundColor={`${Theme === "dark" ? "#dedede" : "#fff"}`}>
                                        <Image src={el.img} w="95%" m="auto" h="150px" mb="20px" ml="-10px" />
                                        <Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} lineHeight={"16px"} mb="2px" fontSize={["13px", "13px", "16px", "16px", "16px"]} fontWeight={"500"} >
                                            {el.name}
                                        </Text>
                                        <Text color="#000" mb="10px" fontSize={["11.5px", "11.5px", "14px", "14px", "14px"]} fontWeight={"500"} >
                                            {el.InsitituteName}
                                        </Text>
                                        <Text color="#000" my="10px" fontSize={["11.5px", "11.5px", "14px", "14px", "14px"]} fontWeight={"400"} >
                                            {el.issueDate}
                                        </Text>
                                        {
                                            el.credentailID !== "" && <Text color="#000" mt="10px" fontSize={["11.5px", "11.5px", "14px", "14px", "14px"]} fontWeight={"400"} >
                                                Credential :<span style={{ fontWeight: "500" }} >{el.credentailID}</span>
                                            </Text>
                                        }
                                        {/* <Box className={`${Theme === "dark" ? "overlay2" : "overlay3"}`} pos="relative">
                                            <Text color={`${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}`} fontSize={["11.5px", "11.5px", "14px", "13px", "13px"]} lineHeight={["14px", "14px", "15px", "15px", "16px"]} fontWeight={"400"}>{el.desc}</Text>
                                            
                                        </Box> */}
                                    </Flex>
                                )
                            })
                        }
                    </Slider>
                </Flex>
            </div>
        </section>

    )
}
function Tilt1(props) {
    const { options, Theme } = props;
    const tilt = React.useRef(null);

    useEffect(() => {
        VanillaTilt.init(tilt.current, options);
    }, [options]);
    useEffect(() => {
        AOS.init();
    }, [])
    return <Box data-aos="zoom-out-down" data-aos-delay="500" data-aos-duration="1000" w={"60%"} ref={tilt} m="auto" pt="150px" >
        <Text color={Theme === "dark" ? "#fff" : "#000"} fontWeight='bold' mb={["2", "2", "2", "2", "20"]} mt="15" fontSize={["25", "25", "25", "35", "40"]} textAlign={"center"} >
            <Highlight
                query={'Certifications'}
                styles={{ color: `${Theme === "dark" ? "#F2AA4CFF" : "#eb584d"}` }}
            >
                My Certifications
            </Highlight>
        </Text>
    </Box>
}
export default Certificates